/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type BulkUpdateUnmatchedDataPoints,
    BulkUpdateUnmatchedDataPointsFromJSON,
    BulkUpdateUnmatchedDataPointsToJSON,
} from '../models/BulkUpdateUnmatchedDataPoints';
import {
    type BulkUpdateUnmatchedDataPointsRequest,
    BulkUpdateUnmatchedDataPointsRequestFromJSON,
    BulkUpdateUnmatchedDataPointsRequestToJSON,
} from '../models/BulkUpdateUnmatchedDataPointsRequest';
import {
    type PaginatedUnmatchedDataPointList,
    PaginatedUnmatchedDataPointListFromJSON,
    PaginatedUnmatchedDataPointListToJSON,
} from '../models/PaginatedUnmatchedDataPointList';
import {
    type UnmatchedDataPointDecision,
    UnmatchedDataPointDecisionFromJSON,
    UnmatchedDataPointDecisionToJSON,
} from '../models/UnmatchedDataPointDecision';
import {
    type UnmatchedDataPointDecisionRequest,
    UnmatchedDataPointDecisionRequestFromJSON,
    UnmatchedDataPointDecisionRequestToJSON,
} from '../models/UnmatchedDataPointDecisionRequest';

export interface UnmatchedDataDecisionsCreateRequest {
    unmatchedDataPointDecisionRequest: UnmatchedDataPointDecisionRequest;
}

export interface UnmatchedDataPointsBulkSaveDecisionCreateRequest {
    bulkUpdateUnmatchedDataPointsRequest: BulkUpdateUnmatchedDataPointsRequest;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    decision?: Array<UnmatchedDataPointsBulkSaveDecisionCreateDecisionEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    search?: string;
}

export interface UnmatchedDataPointsListRequest {
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    decision?: Array<UnmatchedDataPointsListDecisionEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    distanceTo?: string;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    search?: string;
}

/**
 * 
 */
export class UnmatchedDataApi extends runtime.BaseAPI {

    /**
     * Creates request options for unmatchedDataDecisionsCreate without sending the request
     */
    async unmatchedDataDecisionsCreateRequestOpts(requestParameters: UnmatchedDataDecisionsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['unmatchedDataPointDecisionRequest'] == null) {
            throw new runtime.RequiredError(
                'unmatchedDataPointDecisionRequest',
                'Required parameter "unmatchedDataPointDecisionRequest" was null or undefined when calling unmatchedDataDecisionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/unmatched-data/decisions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnmatchedDataPointDecisionRequestToJSON(requestParameters['unmatchedDataPointDecisionRequest']),
        };
    }

    /**
     * A viewset to take and revert decisions on unmatched data points.
     */
    async unmatchedDataDecisionsCreateRaw(requestParameters: UnmatchedDataDecisionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnmatchedDataPointDecision>> {
        const requestOptions = await this.unmatchedDataDecisionsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnmatchedDataPointDecisionFromJSON(jsonValue));
    }

    /**
     * A viewset to take and revert decisions on unmatched data points.
     */
    async unmatchedDataDecisionsCreate(requestParameters: UnmatchedDataDecisionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnmatchedDataPointDecision> {
        const response = await this.unmatchedDataDecisionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unmatchedDataPointsBulkSaveDecisionCreate without sending the request
     */
    async unmatchedDataPointsBulkSaveDecisionCreateRequestOpts(requestParameters: UnmatchedDataPointsBulkSaveDecisionCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkUpdateUnmatchedDataPointsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateUnmatchedDataPointsRequest',
                'Required parameter "bulkUpdateUnmatchedDataPointsRequest" was null or undefined when calling unmatchedDataPointsBulkSaveDecisionCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['decision'] != null) {
            queryParameters['decision'] = requestParameters['decision'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/unmatched-data/points/bulk_save_decision/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateUnmatchedDataPointsRequestToJSON(requestParameters['bulkUpdateUnmatchedDataPointsRequest']),
        };
    }

    /**
     * Take the same decision on every unmatched data point in the queryset.
     */
    async unmatchedDataPointsBulkSaveDecisionCreateRaw(requestParameters: UnmatchedDataPointsBulkSaveDecisionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateUnmatchedDataPoints>> {
        const requestOptions = await this.unmatchedDataPointsBulkSaveDecisionCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateUnmatchedDataPointsFromJSON(jsonValue));
    }

    /**
     * Take the same decision on every unmatched data point in the queryset.
     */
    async unmatchedDataPointsBulkSaveDecisionCreate(requestParameters: UnmatchedDataPointsBulkSaveDecisionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateUnmatchedDataPoints> {
        const response = await this.unmatchedDataPointsBulkSaveDecisionCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unmatchedDataPointsList without sending the request
     */
    async unmatchedDataPointsListRequestOpts(requestParameters: UnmatchedDataPointsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['decision'] != null) {
            queryParameters['decision'] = requestParameters['decision'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distanceTo'] != null) {
            queryParameters['distance_to'] = requestParameters['distanceTo'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/unmatched-data/points/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve unmatched data point information for the table.
     */
    async unmatchedDataPointsListRaw(requestParameters: UnmatchedDataPointsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUnmatchedDataPointList>> {
        const requestOptions = await this.unmatchedDataPointsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUnmatchedDataPointListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve unmatched data point information for the table.
     */
    async unmatchedDataPointsList(requestParameters: UnmatchedDataPointsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUnmatchedDataPointList> {
        const response = await this.unmatchedDataPointsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UnmatchedDataPointsBulkSaveDecisionCreateDecisionEnum = {
    NotOwnedByCompany: 'NOT_OWNED_BY_COMPANY',
    OwnedAndLinkToSite: 'OWNED_AND_LINK_TO_SITE',
    OwnedButNoSite: 'OWNED_BUT_NO_SITE',
    Pending: 'PENDING'
} as const;
export type UnmatchedDataPointsBulkSaveDecisionCreateDecisionEnum = typeof UnmatchedDataPointsBulkSaveDecisionCreateDecisionEnum[keyof typeof UnmatchedDataPointsBulkSaveDecisionCreateDecisionEnum];
/**
 * @export
 */
export const UnmatchedDataPointsListDecisionEnum = {
    NotOwnedByCompany: 'NOT_OWNED_BY_COMPANY',
    OwnedAndLinkToSite: 'OWNED_AND_LINK_TO_SITE',
    OwnedButNoSite: 'OWNED_BUT_NO_SITE',
    Pending: 'PENDING'
} as const;
export type UnmatchedDataPointsListDecisionEnum = typeof UnmatchedDataPointsListDecisionEnum[keyof typeof UnmatchedDataPointsListDecisionEnum];
